/**
 * Offline indicator pill.
 *
 * main.js wires window 'online'/'offline' events and calls
 * setOfflineIndicator(!navigator.onLine) on change and at boot.
 *
 * The pill is a small top-right indicator that does NOT block anything
 * (the app is fully functional offline; this is just a visible cue).
 *
 * Signature matches the Batch 2 stub in src/ui/modal-stubs.js:
 *   setOfflineIndicator(offline: boolean)
 */

const PILL_ID = 'offline-indicator';

/**
 * @param {boolean} offline
 */
export function setOfflineIndicator(offline) {
  const existing = document.getElementById(PILL_ID);

  if (!offline) {
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
    return;
  }

  if (existing) return; // already showing

  const pill = document.createElement('div');
  pill.id = PILL_ID;
  pill.className = 'offline-indicator';
  pill.setAttribute('role', 'status');
  pill.setAttribute('aria-live', 'polite');
  pill.textContent = 'Offline';

  document.body.appendChild(pill);
}
